module.exports = __webpack_public_path__ + "img/块面矩形-激活.2292187c.png";